import {AppUrls} from 'shared/config/model/urls';

import React from 'react';
import {useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import {t} from '@lingui/core/macro';

import {userSelector} from 'entities/user';

import {isTranslate} from 'shared/lib/lang';

import Progress from './Progress/Progress';

import UserInformer from '../../../UserInformer/UserInformer';

import styles from './TariffBanner.module.scss';

const TariffBanner: React.FC = () => {
    const user = useSelector(userSelector);

    const content = React.useMemo(() => {
        if (!user) return <></>;

        return (
            <div className={styles.link_wrapper}>
                <div className={styles.wrapper}>
                    <Link to={isTranslate() ? AppUrls.PRICING : AppUrls.TARIFFS}>
                        <div className={styles.progress}>
                            <Progress percent={user.tariff_days_left_percent} />
                        </div>
                        <div className={styles.remain}>
                            {user.tariff.is_archive && t`Архивный`} {t`Тариф`} -&nbsp;
                            {null !== user.tariff_days_left && ` ${t`Осталось`} `}
                            {user.tariff_days_left_human_readable}
                        </div>
                        <div className={styles.text}>
                            {user.tariff.name}
                        </div>
                    </Link>
                    <span className={styles.line}></span>
                    <UserInformer user={user} />
                </div>
            </div>
        );
    }, [user]);

    return content;
};

export default React.memo(TariffBanner);